// extracted by mini-css-extract-plugin
export default {"main":"cardsf_main__NpDs8","imgblock":"cardsf_imgblock__tXZBq","image":"cardsf_image__VevmH"};